import { User } from '@monsido/modules/models/api/user';

export class UserForm extends User {
    public password?: string;
    public password_confirmation?: string;
    constructor (user: User) {
        super(user);
    }
}
